import queryClient from 'api/queryClient'
import { naturalFeedSessionKey, resetNaturalFeedSessionSnapshot } from 'lib/naturalFeedSession'

export const MESSAGE_REQUEST_COUNT_QUERY_KEY = ['direct-messages', 'request-count']

export async function refreshDirectMessageRequestFeeds() {
    const queries = queryClient.getQueryCache().findAll({
        queryKey: ['quests'],
        predicate: query => {
            const serializedFilter = query.queryKey[1]
            if (typeof serializedFilter !== 'string') return false
            try {
                const filter = JSON.parse(serializedFilter)
                return !!(filter?.private_messages || filter?.private_message_requests)
            } catch {
                return false
            }
        },
    })
    // Explicit request decisions change feed membership, including retained rows.
    for (const query of queries) {
        resetNaturalFeedSessionSnapshot(naturalFeedSessionKey(query.queryKey))
    }
    await Promise.all([
        queryClient.invalidateQueries({ queryKey: MESSAGE_REQUEST_COUNT_QUERY_KEY }),
        ...queries.map(query =>
            queryClient.invalidateQueries({ queryKey: query.queryKey, exact: true }),
        ),
    ])
}
